import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgTrainedIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16 3.4678c1.4817.7363 2.5 2.2653 2.5 4.0322s-1.0183 3.2959-2.5 4.0322m2 5.2342c1.5115.6839 2.8725 1.7986 4 3.2336M2 20c1.9465-2.4774 4.5892-4 7.5-4s5.5535 1.5226 7.5 4M14 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5 9.9853 5 7.5 7.0147 3 9.5 3 14 5.0147 14 7.5"
    />
  </svg>
);
export default SvgTrainedIcon;
